<br><br><br><br>
<div class="page-title">
  <h1 class="title-text">SSE Search</h1>
  <p class="form-desc">
    Use the filter to search the SSE table or use the sorting tools in the table headers to find SSE form.
  </p>
</div>
<p class="form-desc">
  Alternatively, click below to begin a new SSE entry:
</p>
<br>
  <p class="dev-p">
    <a routerLink="/sse-index" class="policy-link" routerLinkActive="active">Create New SSE</a>
  </p>
  <br />
  <br>
    <div class="form-hub-container">
      @if (loading) {
        <div class="loading-spinner">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
      }
      @if (error) {
        <div class="error-message">
          <mat-icon color="warn">error</mat-icon>
          <span>{{ error }}</span>
        </div>
      }
      <div class="search-container">
        <mat-form-field class="search-input">
          <mat-label>Search...</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="" #filterInput>
        </mat-form-field>
      </div>
      @if (!loading && !error) {
        <div>
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>
                Name
                <button class="custom-menu-button" [matMenuTriggerFor]="nameMenu">
                  &#x22EE;
                </button>
                <mat-menu #nameMenu="matMenu" class="custom-menu">
                  <button mat-menu-item (click)="sortData('name', 'asc')">Sort Ascending</button>
                  <button mat-menu-item (click)="sortData('name', 'desc')">Sort Descending</button>
                  <button mat-menu-item (click)="clearSort()">Clear Sorting</button>
                </mat-menu>
              </th>
              <td mat-cell *matCellDef="let element"> {{ element.section1?.hrName || 'N/A' }} </td>
            </ng-container>
            <!-- Index Column -->
            <ng-container matColumnDef="index">
              <th mat-header-cell *matHeaderCellDef> Index </th>
              <td mat-cell *matCellDef="let element">
                <a [routerLink]="['/sse-index', element._id]" class="index-link">Link</a>
              </td>
            </ng-container>
            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>
                Index Status
                <button class="custom-menu-button" [matMenuTriggerFor]="statusMenu">
                  &#x22EE;
                </button>
                <mat-menu #statusMenu="matMenu" class="custom-menu">
                  <button mat-menu-item (click)="sortData('status', 'asc')">Sort Ascending</button>
                  <button mat-menu-item (click)="sortData('status', 'desc')">Sort Descending</button>
                  <button mat-menu-item (click)="clearSort()">Clear Sorting</button>
                </mat-menu>
              </th>
              <td mat-cell *matCellDef="let element"> {{ getIndexStatus(element) }} </td>
            </ng-container>
            <ng-container matColumnDef="checklist">
              <th mat-header-cell *matHeaderCellDef>
                Checklist
                <button class="custom-menu-button" [matMenuTriggerFor]="checklistMenu">
                  &#x22EE;
                </button>
                <mat-menu #checklistMenu="matMenu" class="custom-menu">
                  <button mat-menu-item (click)="sortData('checklist', 'asc')">Sort Ascending</button>
                  <button mat-menu-item (click)="sortData('checklist', 'desc')">Sort Descending</button>
                  <button mat-menu-item (click)="clearSort()">Clear Sorting</button>
                </mat-menu>
              </th>
              <td mat-cell *matCellDef="let element">
                @if (element.sseListId) {
                  <a [routerLink]="['/sse-checklist', element.sseListId]" class="active-link">Active</a>
                }
                @if (!element.sseListId) {
                  <span class="no-checklist">Not Active</span>
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
          </table>
          <!-- No Data Available -->
          @if (dataSource.filteredData.length === 0) {
            <div class="no-data-message">
              <mat-icon color="primary">info</mat-icon>
              <span>No SSE data available.</span>
            </div>
          }
        </div>
      }
    </div>
    <!--
    <mat-card class="mat-mdc-elevation-specific mat-elevation-z8">
      <mat-card-content>
        <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
          <mat-form-field appearance="fill">
            <mat-label>Search SSE Name</mat-label>
            <input matInput formControlName="search" />
          </mat-form-field>

          <div class="submit-button">
            <button mat-raised-button color="primary" type="submit">Search</button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
    <br /><br />
    <hr class="hr" />
    <br /><br />
    <div class="table-group" *ngIf="filteredData.length > 0">
      <table mat-table [dataSource]="filteredData" class="mat-elevation-z8">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> SSE Name </th>
          <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
        </ng-container>


        <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef> Index </th>
          <td mat-cell *matCellDef="let element">
            <a [href]="element.index">Index</a>
          </td>
        </ng-container>


        <ng-container matColumnDef="checklist">
          <th mat-header-cell *matHeaderCellDef> Checklist </th>
          <td mat-cell *matCellDef="let element">
            <a [href]="element.checklist">Checklist</a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    -->


